module.exports = __webpack_public_path__ + "img/02-medal-silver.413c957b.svg";